export const sectores = [
  {Id: 1, Nombre: "EMPLEADO PUBLICO"},
  {Id: 2, Nombre: "INDEPENDIENTE"},
  {Id: 3, Nombre: "PROPIETARIO EMPRESA/INVERSIONISTA"},
  {Id: 4, Nombre: "EMPLEADO PRIVADO"},
]
